import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../helper/PermissionContext";
import AccessDenied from "../pages/AccessDenied/AccessDenied";

// Route path -> permission slug required to open it.
// Add/edit sub-routes inherit their parent module's permission.
const ROUTE_PERMISSIONS = {
  "/": "dashboard",
  "/blog": "blog-management",
  "/ai-blog": "blog-management",
  "/add-ai-blog": "blog-management",
  "/edit-ai-blog": "blog-management",
  "/add-blog": "blog-management",
  "/edit-blog": "blog-management",
  "/category": "blog-management",
  "/author": "blog-management",
  "/tag": "blog-management",
  "/press": "press-management",
  "/add-press": "press-management",
  "/edit-press": "press-management",
  "/seo": "seo-management",
  "/add-seo": "seo-management",
  "/edit-seo": "seo-management",
  "/global-seo": "global-seo",
  "/sitemap": "sitemap-management",
  "/llms": "llms-management",
  "/robots": "robots-management",
  "/faq": "faq-management",
  "/add-faq": "faq-management",
  "/edit-faq": "faq-management",
  "/case": "case-management",
  "/add-case": "case-management",
  "/edit-case": "case-management",
  "/case-category": "case-management",
  "/jobpost": "career",
  "/add-jobpost": "career",
  "/edit-jobpost": "career",
  "/location": "career",
  "/operation": "career",
  "/experience": "career",
  "/location-page": "location-page",
  "/add-locationpage": "location-page",
  "/edit-locationpage": "location-page",
  "/email-management": "email-management",
  "/add-email-management": "email-management",
  "/edit-email-management": "email-management",
  "/contact": "contact-us",
  "/service-form": "service-form",
  "/job-applications": "job-application",
  "/newsletters": "newsletters",
  "/users": "user-management",
  "/roles": "user-management",
  "/permissions": "user-management",
};

// Match by path segments so "/blog" never matches "/blog-management" etc.
const permissionForPath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return ROUTE_PERMISSIONS["/"];
  for (const [key, slug] of Object.entries(ROUTE_PERMISSIONS)) {
    if (key === "/") continue;
    const keySegments = key.split("/").filter(Boolean);
    if (keySegments.every((segment, index) => segments[index] === segment)) return slug;
  }
  return null; // unknown route -> no restriction
};

// Guards the <Outlet />: blocks routes the current user has no permission for.
const RoutePermissionGuard = () => {
  const { pathname } = useLocation();
  const { status, hasPermission } = usePermissions();
  const required = permissionForPath(pathname);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (required && !hasPermission(required)) {
    return <AccessDenied />;
  }

  return <Outlet />;
};

export default RoutePermissionGuard;
